import type { PricingToolTab } from './types';

// Order matches the mockup's card sequence. Preferred Option/Margin live inside Package Options;
// Load Session/Export are toolbar actions, not tabs.
export const PRICING_TOOL_TABS: Array<{ label: string; value: PricingToolTab }> = [
  { label: 'Property Setup', value: 'property-setup' },
  { label: 'Scrape', value: 'scrape' },
  { label: 'Package Options', value: 'package-options' },
  { label: 'Inclusions', value: 'inclusions' },
  { label: 'Pricing Summary', value: 'pricing-summary' },
  { label: 'Blackouts', value: 'blackouts' },
  { label: 'Surcharges', value: 'surcharges' },
  { label: 'EGS', value: 'egs' },
  { label: 'Overrides', value: 'overrides' },
  { label: 'Forecasting', value: 'forecasting' },
];

export function getPricingToolTab(tab: string | null | undefined): PricingToolTab {
  return PRICING_TOOL_TABS.some((pricingToolTab) => pricingToolTab.value === tab)
    ? (tab as PricingToolTab)
    : 'property-setup';
}

export const PRICING_OPTION_LABELS = ['Option 1', 'Option 2', 'Option 3'];

export const OPTION_NAME_PRESETS = ['Gold', 'Diamond', 'Platinum'];

export function optionLabel(optionNames: Record<number, string | undefined>, optionIndex: number): string {
  return optionNames[optionIndex] ?? PRICING_OPTION_LABELS[optionIndex] ?? `Option ${optionIndex + 1}`;
}
